module.exports = __webpack_public_path__ + "static/media/towing.1eec8c1f.svg";